import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Empresa } from '../../entities/empresa';
import { Api } from '../../providers/api/api';

import * as _ from 'lodash';
import * as moment from "moment";

moment.locale('pt-BR');

interface PeriodoOrdemCompraMultiloja {
    Id: string;
    DataEmissao: number;
    MaterialPrimario: number;
    MaterialSecundario: number;
    OutrosMateriais: number;
    TotalOrdemCompra: number;
    Empresa: Empresa;
}

@Component({
    selector: 'periodo-oc-multilojas',
    templateUrl: './periodo-oc-muiltlojas.html'
})
export class PeriodoOrdemCompraMultilojasComponent implements OnInit, OnDestroy {
    public hoje: string = new Date().toISOString();
    public dataInicial: string = new Date("2006-02-17").toISOString();
    public dataFinal: string = new Date().toISOString();

    @Input('analytic') analytic: boolean = false;

    public ordemCompraMultilojaDilady: any;
    public ordemCompraMultilojaLoveSecret: any;
    public ordemCompraMultilojaBanhoDeMar: any;
    public ordemCompraMultilojaGrupo: any;

    public carregandoDados: boolean = true;

    private _myInterval: number;

    constructor(
        private _api: Api
    ) { }

    public ngOnInit(): void {
        this.carregandoDados = true;
        this._separarLojas();

        if (this._myInterval)
            clearInterval(this._myInterval);

        this._myInterval = setInterval(() => {
            this._separarLojas();
        }, 30000);
    }

    public ngOnDestroy(): void {
        clearInterval(this._myInterval);
    }

    private _separarLojas(): void {
        this._obterPeriodoOrdemCompraMultiloja().then(periodosBruto => {
            let periodos = periodosBruto.filter(a => moment(a.DataEmissao).isBetween(this.dataInicial, this.dataFinal));

            this.ordemCompraMultilojaGrupo = {
                MaterialPrimario: _.sum(periodos.map(a => a.MaterialPrimario)),
                MaterialSecundario: _.sum(periodos.map(a => a.MaterialSecundario)),
                OutrosMateriais: _.sum(periodos.map(a => a.OutrosMateriais))
            }
            this.ordemCompraMultilojaGrupo.TotalOrdemCompra = (this.ordemCompraMultilojaGrupo.MaterialPrimario + this.ordemCompraMultilojaGrupo.MaterialSecundario + this.ordemCompraMultilojaGrupo.OutrosMateriais);

            let ordemCompraMultilojaDilady = _.filter(periodos, a => _.isEqual(a.Empresa.Id, 1));
            if (ordemCompraMultilojaDilady.length > 0) {
                this.ordemCompraMultilojaDilady = {
                    MaterialPrimario: _.sum(ordemCompraMultilojaDilady.map(a => a.MaterialPrimario)),
                    MaterialSecundario: _.sum(ordemCompraMultilojaDilady.map(a => a.MaterialSecundario)),
                    OutrosMateriais: _.sum(ordemCompraMultilojaDilady.map(a => a.OutrosMateriais)),
                    Empresa: ordemCompraMultilojaDilady[0].Empresa
                }
                this.ordemCompraMultilojaDilady.TotalOrdemCompra = (this.ordemCompraMultilojaDilady.MaterialPrimario + this.ordemCompraMultilojaDilady.MaterialSecundario + this.ordemCompraMultilojaDilady.OutrosMateriais);
            } else {
                this.ordemCompraMultilojaDilady = {
                    MaterialPrimario: 0,
                    MaterialSecundario: 0,
                    OutrosMateriais: 0,
                    TotalOrdemCompra: 0,
                    Empresa: { Id: 1, Descricao: 'Dilady Lingerie' }
                }
            }

            let ordemCompraMultilojaLoveSecret = _.filter(periodos, a => _.isEqual(a.Empresa.Id, 2));
            if (ordemCompraMultilojaLoveSecret.length > 0) {
                this.ordemCompraMultilojaLoveSecret = {
                    MaterialPrimario: _.sum(ordemCompraMultilojaLoveSecret.map(a => a.MaterialPrimario)),
                    MaterialSecundario: _.sum(ordemCompraMultilojaLoveSecret.map(a => a.MaterialSecundario)),
                    OutrosMateriais: _.sum(ordemCompraMultilojaLoveSecret.map(a => a.OutrosMateriais)),
                    Empresa: ordemCompraMultilojaLoveSecret[0].Empresa
                }
                this.ordemCompraMultilojaLoveSecret.TotalOrdemCompra = (this.ordemCompraMultilojaLoveSecret.MaterialPrimario + this.ordemCompraMultilojaLoveSecret.MaterialSecundario + this.ordemCompraMultilojaLoveSecret.OutrosMateriais);
            } else {
                this.ordemCompraMultilojaLoveSecret = {
                    MaterialPrimario: 0,
                    MaterialSecundario: 0,
                    OutrosMateriais: 0,
                    TotalOrdemCompra: 0,
                    Empresa: { Id: 2, Descricao: 'Love Secret Lingerie' }
                }
            }

            let ordemCompraMultilojaBanhoDeMar = _.filter(periodos, a => _.isEqual(a.Empresa.Id, 3));
            if (ordemCompraMultilojaBanhoDeMar.length > 0) {
                this.ordemCompraMultilojaBanhoDeMar = {
                    MaterialPrimario: _.sum(ordemCompraMultilojaBanhoDeMar.map(a => a.MaterialPrimario)),
                    MaterialSecundario: _.sum(ordemCompraMultilojaBanhoDeMar.map(a => a.MaterialSecundario)),
                    OutrosMateriais: _.sum(ordemCompraMultilojaBanhoDeMar.map(a => a.OutrosMateriais)),
                    Empresa: ordemCompraMultilojaBanhoDeMar[0].Empresa
                }
                this.ordemCompraMultilojaBanhoDeMar.TotalOrdemCompra = (this.ordemCompraMultilojaBanhoDeMar.MaterialPrimario + this.ordemCompraMultilojaBanhoDeMar.MaterialSecundario + this.ordemCompraMultilojaBanhoDeMar.OutrosMateriais);
            } else {
                this.ordemCompraMultilojaBanhoDeMar = {
                    MaterialPrimario: 0,
                    MaterialSecundario: 0,
                    OutrosMateriais: 0,
                    TotalOrdemCompra: 0,
                    Empresa: { Id: 3, Descricao: 'Banho de Mar Acquashape' }
                }
            }

            setTimeout(() => {
                this.carregandoDados = false;
            }, 1000);
        }).catch(error => {
            console.error(error);
        });
    }

    private _obterPeriodoOrdemCompraMultiloja(): Promise<PeriodoOrdemCompraMultiloja[]> {
        return new Promise((resolve, reject) => {
            this._api.get('PeriodoOrdemCompraMultiloja').subscribe(response => resolve(JSON.parse(response._body)), reject);
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/periodo-oc-muiltlojas/periodo-oc-muiltlojas.ts